import { ComparisonPageTemplate } from '@/components/ComparisonPageTemplate'
import { getCompetitor } from '@/data/compare'

export default function YapTrackerComparePage() {
  return <ComparisonPageTemplate competitor={getCompetitor('yaptracker')} />
}
